@file:kotlin.js.JsExport
package com.narbase.letsgo.web.dto.notifications
import com.narbase.letsgo.dto.core.KmmLong

import com.narbase.letsgo.dto.core.DateTimeDto

data class NotificationReadDto(
    val id: KmmLong?,
    val notificationId: KmmLong,
    val driverId: KmmLong?,
    val passengerId: KmmLong?,
    val isSeen: Boolean,
    val seenAt: DateTimeDto?
)
